import { Component, Input, OnInit } from '@angular/core';
import { Post } from '@interfaces/api.post.interface';

@Component({
  selector: 'ark-ui-post-wisee',
  templateUrl: './ui-post-wisee.component.html',
  styleUrls: ['./ui-post-wisee.component.scss'],
})
export class UiPostWiseeComponent {
  @Input() post!: Post;
  constructor() {}
}
